import { createWidget } from '@funtech-int/rival';

export const dcbActivationScreenWidget = createWidget<unknown, {}>();
